import script from "./callback.vue?vue&type=script&setup=true&lang=js"
export * from "./callback.vue?vue&type=script&setup=true&lang=js"

import "./callback.vue?vue&type=style&index=0&id=0b2afe6a&lang=css"

const __exports__ = script;

export default __exports__